<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.2858 17.368L12.8698 2.79297C12.7308 2.55252 12.531 2.35287 12.2904 2.21407C12.0498 2.07527 11.777 2.0022 11.4993 2.0022C11.2215 2.0022 10.9487 2.07527 10.7081 2.21407C10.4676 2.35287 10.2678 2.55252 10.1288 2.79297L1.71277 17.368C1.57395 17.6086 1.50091 17.8815 1.50098 18.1594C1.50104 18.4372 1.57422 18.7101 1.71315 18.9506C1.85208 19.1912 2.05188 19.391 2.29247 19.5299C2.53306 19.6688 2.80596 19.7419 3.08377 19.742H19.9138C20.1916 19.7419 20.4645 19.6688 20.7051 19.5299C20.9457 19.391 21.1455 19.1912 21.2844 18.9506C21.4233 18.7101 21.4965 18.4372 21.4966 18.1594C21.4966 17.8815 21.4246 17.6086 21.2858 17.368Z" fill="#DE0D26"/>
    <rect x="10.5" y="7" width="2" height="7" rx="1" fill="white"/>
    <rect x="10.5" y="15" width="2" height="2" rx="1" fill="white"/>
  </svg>
</template>

<script>

import {defineComponent} from "vue";

export default defineComponent({

  name: "WarningTriangleIcon",

  setup() {
    return {}
  }
})

</script>
